import { modifier } from 'ember-modifier';
import $ from 'jquery';

const searchKeypress = (element: HTMLElement) => {
	function getSearchInputEl() {
		if (!element) {
			return;
		}

		const input = $(element).find('.input-search input:visible');

		if (input.length) {
			const isInPopup = input.closest('.modal-popup').length > 0,
				noPopupsOpen = $('.popup').length === 0;

			if (isInPopup || noPopupsOpen) {
				return input;
			}
		}

		return;
	}

	const focusSearchInputFn = (e: KeyboardEvent) => {
		if ((e.ctrlKey || e.metaKey) && e.keyCode === 'F'.charCodeAt(0)) {
			const searchInput = getSearchInputEl();
			if (searchInput?.length) {
				searchInput.focus();
				e.preventDefault();
			}
		}
	};

	window.addEventListener('keydown', focusSearchInputFn);

	return () => {
		window.removeEventListener('keydown', focusSearchInputFn);
	};
};

const searchKeypressModifier = modifier(searchKeypress);

export default searchKeypressModifier;
